module.exports = {"title":"隱私條款 | GoGoVan 香港","privacy_headline":"Privacy Policy"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/hk/zh_hk/setting/privacy/locale.json
// module id = 628
// module chunks = 0 1 2 3 4 5